import i18n from 'i18next'

export const TAG_FILTER_ALL = 'all'
export const TAG_FILTER_NONE = 'none'

export type TagFilterOption = typeof TAG_FILTER_ALL | typeof TAG_FILTER_NONE | string

export const isTagFilterOption = (value: unknown, availableTags: string[]): value is TagFilterOption => {
    return value === TAG_FILTER_ALL || value === TAG_FILTER_NONE || availableTags.some((tag) => tag === value)
}

export const getTagFilterLabel = (tagFilter: TagFilterOption) => {
    if (tagFilter === TAG_FILTER_ALL) {
        return i18n.t('product.feedback.home.tagFilter.all')
    }

    if (tagFilter === TAG_FILTER_NONE) {
        return i18n.t('product.feedback.home.tagFilter.none')
    }

    return tagFilter
}
